import * as _ from "lodash";
import * as angular from "angular";
import { IssueDataProvider } from "../../../data-provider/issue.dp";
import { UserDataProvider } from "../../../data-provider/user.dp";
import { DialogUtils } from "../../../helper/dialog.helper";
import { PermissionCheck } from "../../../shared/permission";
import { issuePermissionIds } from "../../../utils/user-permissions";

let CreateIssueComponent = {
    selector: "vcCreateIssue",
    templateUrl: "/angular/components/issue/modals/create-issue.component.html",
    bindings: {
        selectedIssue: "=?",
        selectedHoid: "=?",
        selectedCanvasser: "=?",
        dialogType: "=?",
    },
    controller: class CreateIssueController {
        // * bindings for typescript compiler *
        public selectedIssue?: any;
        public selectedHoid?: any;
        public selectedCanvasser?: any;
        public dialogType?: any;
        // ************************************

        private $q: any;
        private $http: any;
        private __env: any;
        private modelsUtils: any;
        private dialog: DialogUtils;
        private searchDelay: any;
        private $interval: any;
        private dataProvider: IssueDataProvider;
        private userDataProvider: UserDataProvider;
        public permissionProvider: PermissionCheck;

        public issue: any;
        public searchPromise: any;
        public houseoccupantSearch: string = "";
        public origins: Array<any> = [];
        public priorities: any;
        public issuePermissions = issuePermissionIds();

        constructor(
            $q: any,
            $http: any,
            __env: any,
            DialogUtils: DialogUtils,
            IssueDataProvider: IssueDataProvider,
            UserDataProvider: UserDataProvider,
            PermissionCheck: PermissionCheck,
            $interval: any,
            ModelsUtils: any
        ) {
            this.$q = $q;
            this.$http = $http;
            this.dialog = DialogUtils;
            this.$interval = $interval;
            this.modelsUtils = ModelsUtils;
            this.dataProvider = IssueDataProvider;
            this.userDataProvider = UserDataProvider;
            this.__env = __env;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            if (this.selectedIssue) {
                this.issue = _.cloneDeep(this.selectedIssue);
            } else {
                if (!this.selectedCanvasser) {
                    this.issue = this.modelsUtils.issue({
                        assigned: this.userDataProvider.getActiveUser(),
                        hoid: this.selectedHoid,
                    });
                } else {
                    this.issue = this.modelsUtils.issue({
                        assigned: this.selectedCanvasser,
                        hoid: this.selectedHoid,
                    });
                }
            }

            if (!this.issue.origin) {
                this.issue.origin = {
                    csqoid: this.issue.csqoid,
                    csqoname: this.issue.csqoname,
                };
            }

            this.dataProvider.getOrigins().then((origins) => {
                this.origins = origins;

                if (!this.issue.origin || !this.issue.origin.csqoid) {
                    this.issue.origin = this.origins[0];
                }
            });

            this.dataProvider.getPriorities().then((priorities) => {
                this.priorities = priorities;
            });
        }

        filterPeople(searchText: string): Promise<any> {
            if (this.searchDelay) {
                this.searchDelay = this.$interval.cancel(this.searchDelay);
            }
            const deferred = this.$q.defer();
            this.searchDelay = this.$interval(() => {
                this.$interval.cancel(this.searchDelay);
                if (this.searchPromise)
                    this.searchPromise.resolve("user cancelled");
                this.searchPromise = this.$q.defer();

                const searchSpecialCharsRemoved = searchText.replace(
                    /[^a-z0-9,.@ ]/gi,
                    " "
                );

                this.$http({
                    url: this.__env.apiUrl() + "/houseoccupant/all/",
                    method: "GET",
                    params: {
                        filters: { search: searchSpecialCharsRemoved },
                        count: 1,
                    },
                    timeout: this.searchPromise.promise,
                }).then((response) => {
                    if (!response || !response.data || !response.data.data)
                        deferred.reject();
                    deferred.resolve(response.data.data.slice(0, 9));
                });
                return deferred.promise;
            }, 500);

            return deferred.promise;
        }

        confirm(): void {
            if (!this.issue.hoid && this.issue.houseoccupant) {
                this.issue.hoid = this.issue.houseoccupant.hoid;
            }
            if (!this.issue.assigned && this.issue.assigned.uid) {
                this.issue.assigned = this.issue.assigned.uid;
            }
            this.dialog.hide(this.issue);
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("issue")
    .component(CreateIssueComponent.selector, CreateIssueComponent);
